const checkbox = {
  baseStyle: {
    control: {
      borderRadius: 'md',
      background: 'white',
    },
  },
  sizes: {
    sm: {
      control: {
        h: '3', w: '3',
      },
    },
    md: {
      control: {
        h: '4', w: '4',
      },
    },
  },
};

export default checkbox;
